export const EarnedData = {
  leaveid: null,
  parentid: null,
  leavetypeid: 1,
  leavecategoryid: 1,
  leavename: '',
  description: 'My Earned',
  earnedleave: 0,
  completionday: 0,
  credittypeid: 0,
  ispresentday: false,
  isleave: false,
  isabsentday: false,
  iswekkoff: false,
  isholiday: false,
  employeetypeids: null,
  proratetypeid: 0,
  creditmodetypeid: 0,
  midjoinstartday: 0,
  isextentionprobation: false,
  isprobationaccurallimit: false,
  isattachment: false,
  attachmentduration: 0,
  attachmentnote: '',
  maxleaveinprobation: 0,
  maxleave: 1,
  maxleavedurationtypeid: 0,
  maxconsecutiveleave: 1,
  maxconsecutiveleavedurationtypeid: 0,
  isallowhalfday: false,
  isfurtureappallowed: false,
  minleavecountforapp: 1,
  notifyinadvanceday: 1,
  notifynotbeforeday: 1,
  ispastappallowed: false,
  apppastday: 1,
  isleaveallowedinnotice: false,
  leavecountinnotice: 1,
  isintervinigallowed: false,
  interviningpolicy: {
    isinterviningholiday: false,
    holidayinterviningcount: 0,
    isholidayinterviningclubbed: false,
    isprefixholiday: false,
    holidayprefixcount: 0,
    issuffixholiday: false,
    holidaysuffixcount: 0,
    isinterviningoptholiday: false,
    optholidayinterviningcount: 0,
    isoptholidayinterviningclubbed: false,
    isprefixoptholiday: false,
    optholidayprefixcount: 0,
    issuffixoptholiday: false,
    optholidaysuffixcount: 0,
    isinterviningweeklyoff: false,
    weeklyoffinterviningcount: 0,
    isweeklyoffinterviningclubbed: false,
    isprefixweeklyoff: false,
    weeklyoffprefixcount: 0,
    issuffixweeklyoff: false,
    weeklyoffsuffixcount: 0,
  },
  isclubbingallowed: false,
  clubbingleaveid: null,
  isoverutilizationallowed: false,
  overutilizationpolicy: {
    excessleaveactiontypeid: 0,
    excesspaidlimit: 0,
    altleaveid: null,
    altexcessleaveactiontypeid: 0,
    altleavetypeid: 0,
  },
  iscarryforwardallowed: false,
  carryforward: {
    iscarryforwardpolicy: false,
    carryforwardpolicy: {
      forwardtypeid: 0,
      carryforwardunusedperc: 0,
      carryforwardunused: 0,
      pendingactiontypeid: 0,
      remaningtypeid: 0,
      remaningperc: 0,
      noofremaning: 0,
      transferleaveid: 0,

    },
    encashmentpolicy: {
      encashmenttypeid: 0,
      encashmentunusedperc: 0,
      encashmentunused: 0,
      pendingactiontypeid: 0,
      remaningtypeid: 0,
      remaningperc: 0,
      noofremaning: 0,
      transferleaveid: 0,
    },
  },
  isgiftallowed: false,
  giftactiontypeid: 0,
  giftperc: 0,
  noofgift: 0,
  isgiftapproval: false,
  datastate: 1,
};
